import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DISPOSABLE_DOMAINS = [
  'mailinator.com', 'tempmail.com', 'throwaway.email', 'guerrillamail.com',
  'sharklasers.com', 'guerrillamail.info', 'grr.la', 'guerrillamail.biz',
  'guerrillamail.de', 'guerrillamail.net', 'guerrillamail.org',
  'tempmail.de', 'temp-mail.org', 'temp-mail.io', 'tempail.com',
  'tempr.email', 'tempmailo.com', 'dispostable.com', 'yopmail.com',
  'yopmail.fr', 'trashmail.com', 'trashmail.me', 'trashmail.net',
  'fakeinbox.com', 'mailnesia.com', 'maildrop.cc', 'discard.email',
  'mailcatch.com', 'trash-mail.com', 'mytemp.email', 'mohmal.com',
  'getnada.com', 'emailondeck.com', 'tempinbox.com', '10minutemail.com',
  '10minmail.com', 'minutemail.com', 'emailfake.com', 'armyspy.com',
  'cuvox.de', 'dayrep.com', 'einrot.com', 'fleckens.hu', 'gustr.com',
  'jourrapide.com', 'rhyta.com', 'superrito.com', 'teleworm.us',
  'mailnull.com', 'spamgourmet.com', 'getairmail.com', 'mailexpire.com',
  'safetymail.info', 'filzmail.com', 'inboxalias.com', 'jetable.org',
  'nospam.ze.tc', 'kurzepost.de', 'objectmail.com', 'proxymail.eu',
  'rcpt.at', 'trash-mail.at', 'trashmail.at', 'wegwerfmail.de',
  'wegwerfmail.net', 'wegwerfmail.org', 'wuzup.net', 'binkmail.com',
  'bobmail.info', 'chammy.info', 'devnullmail.com', 'letthemeatspam.com',
  'mailblocks.com', 'mailforspam.com', 'spambox.us',
  'spamfree24.org', 'trashymail.com', 'antispam.de', 'bspamfree.org',
  'emz.net', 'mail-temporaire.fr', 'courrieltemporaire.com', 'tempomail.fr',
  'ephemail.net', 'mailtemp.info', 'tempmailer.com', 'throwam.com',
  'mailnator.com', 'guerrillamailblock.com', 'pokemail.net', 'spam4.me',
  'grr.la', 'guerrillamail.com', 'meltmail.com', 'harakirimail.com'
];

const FAKE_PHONE_PATTERNS = [
  '0000000000', '1111111111', '2222222222', '3333333333', '4444444444',
  '5555555555', '6666666666', '7777777777', '8888888888', '9999999999',
  '1234567890', '0123456789'
];

const RegisterPage = ({ onComplete, onBack }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [formData, setFormData] = useState({
    firstName: '',
    function: '',
    customFunction: '',
    region: '',
    experience: '',
    salary: '',
    email: '',
    confirmEmail: '',
    phone: '',
    searchStatus: '',
    contractType: '',
    industry: '',
    privacyAccepted: false
  });

  const functions = [
    'Elektricien',
    'Loodgieter',
    'HVAC-technicus',
    'CNC-operator',
    'Lasser',
    'Monteur',
    'Mechanicien',
    'Industrieel elektricien',
    'Onderhoudstechnicus',
    'Procesoperator',
    'PLC-programmeur',
    'Andere'
  ];

  const regions = [
    'Antwerpen',
    'Oost-Vlaanderen',
    'West-Vlaanderen',
    'Vlaams-Brabant',
    'Limburg',
    'Brussel',
    'Waals-Brabant',
    'Henegouwen',
    'Luik',
    'Luxemburg',
    'Namen'
  ];

  const experienceOptions = [
    { value: '0', label: '0-1 jaar' },
    { value: '2', label: '2-3 jaar' },
    { value: '4', label: '4-5 jaar' },
    { value: '6', label: '6-10 jaar' },
    { value: '11', label: '10+ jaar' }
  ];

  const contractTypes = [
    { value: 'vast', label: 'Vast' },
    { value: 'interim', label: 'Interim' },
    { value: 'freelance', label: 'Freelance' }
  ];

  const industries = [
    'Automotive',
    'Bouw & Infrastructuur',
    'Chemie & Farma',
    'Elektrotechniek',
    'Energie & Utilities',
    'Food & Beverage',
    'HVAC & Koeltechniek',
    'Logistiek & Transport',
    'Machinebouw',
    'Metaalbewerking',
    'Onderhoud & Facility',
    'Petrochemie',
    'Productie & Manufacturing',
    'Scheepsbouw',
    'Telecom & IT',
    'Andere'
  ];

  const searchStatusOptions = [
    { value: 'actief', label: 'Actief op zoek', description: 'Ik zoek actief naar een nieuwe job' },
    { value: 'verkennend', label: 'Verkennend', description: 'Ik sta open voor interessante kansen' },
    { value: 'niet_actief', label: 'Niet actief', description: 'Ik ben momenteel niet op zoek' }
  ];

  const validateForm = () => {
    const errors = {};
    const trimmedName = formData.firstName.trim();

    // Name: required, min 2 chars
    if (!trimmedName) {
      errors.firstName = 'Naam is verplicht';
    } else if (trimmedName.length < 2) {
      errors.firstName = 'Naam moet minstens 2 tekens bevatten';
    }

    // Function: required
    if (!formData.function) {
      errors.function = 'Selecteer een functie';
    } else if (formData.function === 'Andere' && !formData.customFunction.trim()) {
      errors.customFunction = 'Specifieer je functie';
    }

    // Region: required
    if (!formData.region) {
      errors.region = 'Selecteer een regio';
    }

    // Experience: required
    if (formData.experience === '') {
      errors.experience = 'Selecteer je ervaring';
    }

    // Email: required, format, disposable check
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const trimmedEmail = formData.email.trim().toLowerCase();
    if (!trimmedEmail) {
      errors.email = 'E-mailadres is verplicht';
    } else if (!emailRegex.test(trimmedEmail)) {
      errors.email = 'Voer een geldig e-mailadres in (bv. naam@domein.be)';
    } else {
      const domain = trimmedEmail.split('@')[1];
      if (DISPOSABLE_DOMAINS.includes(domain)) {
        errors.email = 'Gebruik een professioneel e-mailadres (geen tijdelijke e-mail)';
      }
    }

    // Confirm email: required, must match
    const trimmedConfirm = formData.confirmEmail.trim().toLowerCase();
    if (!trimmedConfirm) {
      errors.confirmEmail = 'Bevestig je e-mailadres';
    } else if (trimmedEmail !== trimmedConfirm) {
      errors.confirmEmail = 'E-mailadressen komen niet overeen';
    }

    // Phone: required, format, length, fake check
    const phoneRaw = formData.phone.trim();
    const digitsOnly = phoneRaw.replace(/[\s\-\+\(\)]/g, '');
    if (!phoneRaw) {
      errors.phone = 'Telefoonnummer is verplicht';
    } else if (!/^\+?[\d\s\-\(\)]+$/.test(phoneRaw)) {
      errors.phone = 'Alleen cijfers, +, spaties en streepjes zijn toegestaan';
    } else if (digitsOnly.length < 9 || digitsOnly.length > 15) {
      errors.phone = 'Telefoonnummer moet tussen 9 en 15 cijfers bevatten';
    } else if (FAKE_PHONE_PATTERNS.includes(digitsOnly)) {
      errors.phone = 'Dit telefoonnummer lijkt niet geldig';
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
    if (fieldErrors[name]) {
      setFieldErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^\d\+\s\-\(\)]/g, '');
    setFormData(prev => ({ ...prev, phone: value }));
    if (fieldErrors.phone) {
      setFieldErrors(prev => ({ ...prev, phone: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!validateForm()) {
      return;
    }

    if (!formData.privacyAccepted) {
      setError('Je moet akkoord gaan met het privacybeleid om verder te gaan.');
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/early-access`, { 
        email: formData.email.trim() 
      });
      
      if (response.data) {
        await axios.post(`${API}/early-access/role`, { 
          email: formData.email.trim(), 
          role: 'candidate' 
        });

        await axios.post(`${API}/candidate-profile`, {
          email: formData.email.trim(),
          firstName: formData.firstName.trim(),
          function: formData.function === 'Andere' ? formData.customFunction.trim() : formData.function,
          region: formData.region,
          experience: parseInt(formData.experience) || 0,
          salary: parseInt(formData.salary) || 0,
          phone: formData.phone.trim(),
          searchStatus: formData.searchStatus,
          contractType: formData.contractType,
          industry: formData.industry,
          privacyAccepted: formData.privacyAccepted,
          privacyAcceptedAt: new Date().toISOString()
        });

        onComplete(formData.email.trim());
      }
    } catch (err) {
      if (err.response?.status === 422) {
        const detail = err.response?.data?.detail;
        if (Array.isArray(detail)) {
          const messages = detail.map(d => d.msg).join('. ');
          setError(messages || 'Controleer je gegevens en probeer opnieuw.');
        } else {
          setError('Controleer je gegevens en probeer opnieuw.');
        }
      } else {
        setError('Er ging iets mis. Probeer het opnieuw.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getInputStyle = (fieldName) => ({
    borderColor: fieldErrors[fieldName] ? '#ef4444' : '#d1d5db',
    backgroundColor: '#ffffff',
    color: '#1A4D2E',
  });

  const getSelectStyle = (fieldName) => ({
    ...getInputStyle(fieldName),
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
    backgroundPosition: 'right 0.75rem center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.5em 1.5em',
    paddingRight: '2.5rem',
  });

  const FieldError = ({ field }) => {
    if (!fieldErrors[field]) return null;
    return (
      <p className="text-xs mt-1" style={{ color: '#ef4444' }} data-testid={`error-${field}`}>
        {fieldErrors[field]}
      </p>
    );
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center px-6 py-12"
      style={{ background: '#F5EFE6' }}
      data-testid="register-page"
    >
      <div className="w-full max-w-md mx-auto">
        {onBack && (
          <button
            onClick={onBack}
            style={{ background: 'none', border: 'none', color: '#1A4D2E', opacity: 0.6, fontSize: 14, cursor: 'pointer', padding: 0, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'inherit' }}
            data-testid="register-back-btn"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            Terug
          </button>
        )}
        <h2 
          className="text-xl sm:text-2xl font-bold mb-2 text-center"
          style={{ color: '#1A4D2E' }}
          data-testid="register-heading"
        >
          Maak je profiel aan
        </h2>
        
        <p 
          className="text-center mb-6 text-sm"
          style={{ color: '#1A4D2E', opacity: 0.7 }}
          data-testid="register-subtitle"
        >
          Dit duurt minder dan 2 minuten.
        </p>

        {error && (
          <p 
            className="text-red-600 text-sm mb-4 text-center bg-red-50 p-3 rounded-lg"
            data-testid="register-error"
          >
            {error}
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-3" noValidate>
          {/* Voornaam */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Voornaam *
            </label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="Voornaam"
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all"
              style={getInputStyle('firstName')}
              data-testid="input-firstname"
            />
            <FieldError field="firstName" />
          </div>

          {/* Functie */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Functie *
            </label>
            <select
              name="function"
              value={formData.function}
              onChange={handleChange}
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all cursor-pointer"
              style={getSelectStyle('function')}
              data-testid="input-function"
            >
              <option value="">Selecteer je functie</option>
              {functions.map((func) => (
                <option key={func} value={func}>{func}</option>
              ))}
            </select>
            <FieldError field="function" />
          </div>

          {formData.function === 'Andere' && (
            <div>
              <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
                Specifieer je functie *
              </label>
              <input
                type="text"
                name="customFunction"
                value={formData.customFunction}
                onChange={handleChange}
                placeholder="Vul je functie in"
                disabled={isLoading}
                className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all"
                style={getInputStyle('customFunction')}
                data-testid="input-custom-function"
              />
              <FieldError field="customFunction" />
            </div>
          )}

          {/* Regio */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Regio *
            </label>
            <select
              name="region"
              value={formData.region}
              onChange={handleChange}
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all cursor-pointer"
              style={getSelectStyle('region')}
              data-testid="input-region"
            >
              <option value="">Selecteer je regio</option>
              {regions.map((region) => (
                <option key={region} value={region}>{region}</option>
              ))}
            </select>
            <FieldError field="region" />
          </div>

          {/* Ervaring */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Ervaring *
            </label>
            <select
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all cursor-pointer"
              style={getSelectStyle('experience')}
              data-testid="input-experience"
            >
              <option value="">Selecteer je ervaring</option>
              {experienceOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <FieldError field="experience" />
          </div>

          {/* Contract Type */}
          <div>
            <label className="block text-xs mb-2 font-medium" style={{ color: '#1A4D2E' }}>
              Contract type *
            </label>
            <div className="flex gap-2">
              {contractTypes.map((type) => (
                <button
                  key={type.value}
                  type="button"
                  onClick={() => setFormData(prev => ({ ...prev, contractType: type.value }))}
                  disabled={isLoading}
                  className={`flex-1 py-2 px-3 text-sm font-medium border transition-all cursor-pointer ${
                    formData.contractType === type.value 
                      ? 'border-green-700' 
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                  style={{
                    borderColor: formData.contractType === type.value ? '#1A4D2E' : '#d1d5db',
                    backgroundColor: formData.contractType === type.value ? 'rgba(26, 77, 46, 0.08)' : '#ffffff',
                    color: '#1A4D2E'
                  }}
                  data-testid={`contract-${type.value}`}
                >
                  {type.label}
                </button>
              ))}
            </div>
          </div>

          {/* Search Status */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Hoe actief ben je op zoek? *
            </label>
            <select
              name="searchStatus"
              value={formData.searchStatus}
              onChange={handleChange}
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all cursor-pointer"
              style={getSelectStyle('searchStatus')}
              data-testid="input-search-status"
            >
              <option value="">Selecteer je zoekstatus</option>
              {searchStatusOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          {/* Industry */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Industrie *
            </label>
            <select
              name="industry"
              value={formData.industry}
              onChange={handleChange}
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all cursor-pointer"
              style={getSelectStyle('industry')}
              data-testid="input-industry"
            >
              <option value="">Selecteer je industrie</option>
              {industries.map((ind) => (
                <option key={ind} value={ind}>{ind}</option>
              ))}
            </select>
          </div>

          {/* Salary */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Gewenst loon (euro / maand) *
            </label>
            <input
              type="number"
              name="salary"
              value={formData.salary}
              onChange={handleChange}
              placeholder="Bijv. 3500"
              min="0"
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all"
              style={getInputStyle('salary')}
              data-testid="input-salary"
            />
          </div>

          {/* Phone */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Telefoonnummer *
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handlePhoneChange}
              placeholder="+32 xxx xx xx xx"
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all"
              style={getInputStyle('phone')}
              data-testid="input-phone"
            />
            <FieldError field="phone" />
          </div>

          {/* Email */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              E-mailadres *
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="jouw@email.be"
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all"
              style={getInputStyle('email')}
              data-testid="input-email"
            />
            <FieldError field="email" />
          </div>

          {/* Confirm Email */}
          <div>
            <label className="block text-xs mb-1 font-medium" style={{ color: '#1A4D2E' }}>
              Bevestig e-mailadres *
            </label>
            <input
              type="email"
              name="confirmEmail"
              value={formData.confirmEmail}
              onChange={handleChange}
              placeholder="Herhaal je e-mailadres"
              disabled={isLoading}
              className="w-full px-3 py-2 text-sm border focus:outline-none focus:ring-2 focus:ring-green-800/20 transition-all"
              style={getInputStyle('confirmEmail')}
              data-testid="input-confirm-email"
            />
            <FieldError field="confirmEmail" />
          </div>

          {/* Privacy Consent */}
          <div className="pt-3 border-t" style={{ borderColor: 'rgba(26, 77, 46, 0.15)' }}>
            <label className="flex items-start cursor-pointer">
              <input
                type="checkbox"
                name="privacyAccepted"
                checked={formData.privacyAccepted}
                onChange={handleChange}
                disabled={isLoading}
                className="mt-0.5 mr-2 w-4 h-4 rounded"
                style={{ accentColor: '#1A4D2E' }}
                data-testid="input-privacy"
              />
              <span className="text-xs" style={{ color: '#1A4D2E', opacity: 0.8 }}>
                Ik ga akkoord met het{' '}
                <a 
                  href="/privacy" 
                  target="_blank"
                  className="underline font-medium"
                  style={{ color: '#1A4D2E' }}
                >
                  privacybeleid
                </a>{' '}
                en de{' '}
                <a 
                  href="/terms" 
                  target="_blank"
                  className="underline font-medium"
                  style={{ color: '#1A4D2E' }}
                >
                  algemene voorwaarden
                </a>
                . Ik begrijp dat mijn gegevens worden verwerkt conform de GDPR-wetgeving. *
              </span>
            </label>
          </div>

          <button
            type="submit"
            disabled={isLoading || !formData.privacyAccepted}
            className="w-full py-3 px-6 text-sm font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90 active:scale-[0.98] mt-4"
            style={{
              backgroundColor: '#1A4D2E',
              color: '#F5EFE6',
            }}
            data-testid="submit-button"
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Even geduld...
              </span>
            ) : (
              'Profiel aanmaken'
            )}
          </button>
        </form>

        <p 
          className="mt-4 text-xs text-center"
          style={{ color: '#1A4D2E', opacity: 0.6 }}
          data-testid="register-note"
        >
          Geen cv · Geen recruiters · Jij beslist
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
